// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__-6s8Q","colMin":"styles_colMin__2H94U"};